Retorna grupos de transferência que podem ser referenciados como alvos de transferência na API pública.

<ApiCodeExamples exampleId="transferGroupsList" />

<ApiResponseExamples exampleId="transferGroupsList" />

## Escopo obrigatório

- `transfer_groups.read`

## Endpoints

- `GET /public/v1/transfer-groups/`: lista paginada.
- `GET /public/v1/transfer-groups/{id}/`: detalhe de um grupo de transferência.

O detalhe usa o mesmo formato de campo do item da lista. Membros não são retornados por padrão.

## Query parameters

- `page` (`integer`, opcional): número da página.
- `page_size` (`integer`, opcional): quantidade de itens por página. Default `25`, máximo `100`.
- `search` (`string`, opcional): busca por nome do grupo.
- `ordering` (`string`, opcional): `name`, `strategy`, `is_active`, `updated_at`, ou os mesmos campos com prefixo `-`.
- `transfer_eligible` (`boolean`, opcional): `true` para grupos ativos com pelo menos um membro elegível, `false` para grupos que não podem receber transferência agora.

## Campos de resposta

- `id` (`uuid`): id público do grupo para `transfer_target.id`.
- `name` (`string`): nome do grupo.
- `is_active` (`boolean`): indica se o grupo está ativo.
- `transfer_eligible` (`boolean`): indica se o grupo tem pelo menos um membro ativo com endpoint elegível.
- `strategy` (`string`): estratégia de distribuição.
- `eligible_members_count` (`integer`): quantidade de membros ativos e elegíveis.
- `updated_at` (`datetime`): data da última atualização.

## Referência de opções

- `strategy`: `rrmemory`, `leastrecent`, `fewestcalls`, `ringall`.
- `transfer_eligible=true` exige grupo ativo com pelo menos um membro ativo e elegível.

## Erros esperados

- `401 Unauthorized`: token inválido, expirado, revogado, ausente ou bloqueado por IP.
- `403 Forbidden`: a credencial não possui `transfer_groups.read`.
- `404 Not Found`: o id do detalhe não está disponível para a organização.
- `429 Too Many Requests`: rate limit da credencial excedido.
